import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=db91d06e"
import script from "../../../scripts/partials/dashboard-charts/BarChart.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/dashboard-charts/BarChart.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports